import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonDatetime, IonHeader, IonIcon, IonLoading, IonPage, IonPopover, IonSelect, IonSelectOption, IonTitle, IonToast, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import dayjs from 'dayjs';
import { calendarOutline, arrowBack } from 'ionicons/icons';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useContext, useRef, useState } from 'react';
import { CSVLink } from "react-csv";
import { useHistory } from 'react-router-dom';
import { urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import GeralTable from './GeralTable';
import '../RelatoriosLayout.css';

type Props = {
  abrirMenu: boolean;
}

const RelatorioGeral: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [lojaSelecionadaId, setLojaSelecionadaId] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaId || "");
  const [lojaSelecionadaNome, setLojaSelecionadaNome] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaNome || "");
  const [stateLastEvaluatedKey, setStateLastEvaluatedKey] = useState<any>();
  const [stateGeral, setStateGeral] = useState<any>([]);
  const [stateCarregado, setStateCarregado] = useState<boolean>(false);
  const [stateStatus, setStateStatus] = useState<any>("Encerrado");

  const popover1 = useRef<HTMLIonPopoverElement>(null);
  const popover2 = useRef<HTMLIonPopoverElement>(null);

  const [showModalDataInicio, setShowModalDataInicio] = useState(false);
  const [showModalDataFim, setShowModalDataFim] = useState(false);

  const [dataAgendamentoPeriodo1, setDataAgendamentoPeriodo1] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo1Br, setDataAgendamentoPeriodo1Br] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2, setDataAgendamentoPeriodo2] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2Br, setDataAgendamentoPeriodo2Br] = useState<any>("Selecione");

  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
  });

  async function carregarCaixaSegmentada(filtro: any, lojasParam: any, data: string) {
    const consultar = async () => {

      if (dataAgendamentoPeriodo1Br == "Selecione" || dataAgendamentoPeriodo2Br == "Selecione") {
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return null;
      }

      let msDiffDay = dayjs(dataAgendamentoPeriodo2).diff(dayjs(dataAgendamentoPeriodo1), 'day');

      if (msDiffDay < 0) {
        setTextToast("Data fim não pode ser menor que Data início.");
        setShowToast(true);
        return null;
      }
      else if (msDiffDay > 31) {
        setTextToast("Intervalo da data não pode ser maior que 31 dias.");
        setShowToast(true);
        return null;
      }

      setStateCarregado(true);
      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');

      let urlFinal = urlBaseCore.url + "/ordens/relatoriocc?campo=data" +
        "&valor=" + dataFormatada +
        "&valor2=" + dataFormatada2 +
        "&filtro=" + filtro +
        "&filtro2=caixa" +
        "&lojas=" + Buffer.from(lojasParam).toString('base64');

      const resp: Response = await fetch(urlFinal,
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }

      if (res && res.LastEvaluatedKey) {
        setStateLastEvaluatedKey(res.LastEvaluatedKey);
      }
      else {
        setStateLastEvaluatedKey(null);
      }

      setShowLoading(false);
      if (res && res.Items) {
        return res.Items;
      }
      else {
        return null;
      }
    };
    return await consultar();
  }

  async function carregarComandasSegmentada(filtro: any, lojasParam: any, data: string) {
    const consultar = async () => {

      if (dataAgendamentoPeriodo1Br == "Selecione" || dataAgendamentoPeriodo2Br == "Selecione") {
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return null;
      }

      let msDiffDay = dayjs(dataAgendamentoPeriodo2).diff(dayjs(dataAgendamentoPeriodo1), 'day');

      if (msDiffDay < 0) {
        setTextToast("Data fim não pode ser menor que Data início.");
        setShowToast(true);
        return null;
      }
      else if (msDiffDay > 31) {
        setTextToast("Intervalo da data não pode ser maior que 31 dias.");
        setShowToast(true);
        return null;
      }

      setStateCarregado(true);
      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');

      let urlFinal = urlBaseCore.url + "/ordens/relatoriocc?campo=data" +
        "&valor=" + dataFormatada +
        "&valor2=" + dataFormatada2 +
        "&filtro=" + filtro +
        "&filtro2=comandas" +
        "&lojas=" + Buffer.from(lojasParam).toString('base64');

      const resp: Response = await fetch(urlFinal,
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }

      if (res && res.LastEvaluatedKey) {
        setStateLastEvaluatedKey(res.LastEvaluatedKey);
      }
      else {
        setStateLastEvaluatedKey(null);
      }

      setShowLoading(false);
      if (res && res.Items) {
        return res.Items;
      }
      else {
        return null;
      }
    };
    return await consultar();
  }

  async function carregarTotemSegmentada(filtro: any, lojasParam: any, data: string) {
    const consultar = async () => {

      if (dataAgendamentoPeriodo1Br == "Selecione" || dataAgendamentoPeriodo2Br == "Selecione") {
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return null;
      }

      let msDiffDay = dayjs(dataAgendamentoPeriodo2).diff(dayjs(dataAgendamentoPeriodo1), 'day');

      if (msDiffDay < 0) {
        setTextToast("Data fim não pode ser menor que Data início.");
        setShowToast(true);
        return null;
      }
      else if (msDiffDay > 31) {
        setTextToast("Intervalo da data não pode ser maior que 31 dias.");
        setShowToast(true);
        return null;
      }

      setStateCarregado(true);
      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');

      let urlFinal = urlBaseCore.url + "/ordens/relatoriocc?campo=data" +
        "&valor=" + dataFormatada +
        "&valor2=" + dataFormatada2 +
        "&filtro=" + filtro +
        "&filtro2=totem" +
        "&lojas=" + Buffer.from(lojasParam).toString('base64');

      const resp: Response = await fetch(urlFinal,
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }

      if (res && res.LastEvaluatedKey) {
        setStateLastEvaluatedKey(res.LastEvaluatedKey);
      }
      else {
        setStateLastEvaluatedKey(null);
      }

      setShowLoading(false);
      if (res && res.Items) {
        return res.Items;
      }
      else {
        return null;
      }
    };
    return await consultar();
  }

  async function carregarGeralSegmentada(filtro: any, lojasParam: any, data: string) {
    const consultar = async () => {

      if (dataAgendamentoPeriodo1Br == "Selecione" || dataAgendamentoPeriodo2Br == "Selecione") {
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return null;
      }

      let msDiffDay = dayjs(dataAgendamentoPeriodo2).diff(dayjs(dataAgendamentoPeriodo1), 'day');

      if (msDiffDay < 0) {
        setTextToast("Data fim não pode ser menor que Data início.");
        setShowToast(true);
        return null;
      }
      else if (msDiffDay > 31) {
        setTextToast("Intervalo da data não pode ser maior que 31 dias.");
        setShowToast(true);
        return null;
      }

      setStateCarregado(true);
      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');

      let urlFinal = urlBaseCore.url + "/ordens/relatorio?campo=data" +
        "&valor=" + dataFormatada +
        "&valor2=" + dataFormatada2 +
        "&filtro=" + filtro +
        "&lojas=" + Buffer.from(lojasParam).toString('base64');

      const resp: Response = await fetch(urlFinal,
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }

      if (res && res.LastEvaluatedKey) {
        setStateLastEvaluatedKey(res.LastEvaluatedKey);
      }
      else {
        setStateLastEvaluatedKey(null);
      }

      setShowLoading(false);
      if (res && res.Items) {
        return res.Items;
      }
      else {
        return null;
      }
    };
    return await consultar();
  }

  async function carregarDados(situacao: any, cliente: any, data: any, exportFunction?: any) {
    setShowLoading(true);

    const [pedidos, caixa, comandas, totem] = await Promise.all([
      carregarGeralSegmentada(situacao, cliente, data),
      carregarCaixaSegmentada(situacao, cliente, data),
      carregarComandasSegmentada(situacao, cliente, data),
      carregarTotemSegmentada(situacao, cliente, data)
    ]);

    let arrayGeral: any[] = [];
    let somaValor = 0;
    let somaSubtotal = 0;
    let contador = 0;

    arrayGeral.push(['#', 'Data', 'Produto', 'Qtd', 'Valor', 'Total', 'Nome', 'Origem']);

    // Cria lista com origem marcada
    const todosItens = [
      ...(pedidos || []).map((item: any) => ({ ...item, origem: window.localStorage.getItem("servicoTipoPlural") || "Projetos" })),
      ...(caixa || []).map((item: any) => ({ ...item, origem: 'Balcão' })),
      ...(comandas || []).map((item: any) => ({ ...item, origem: window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas" })),
      ...(totem || []).map((item: any) => ({ ...item, origem: 'Totem' }))
    ];

    // Ordenar por dataCadastro
    todosItens.sort((a, b) => new Date(a.dataCadastro).getTime() - new Date(b.dataCadastro).getTime());

    todosItens.forEach((pedido: any) => {
      if (!pedido.produtos || !Array.isArray(pedido.produtos)) return;

      pedido.produtos.forEach((item: any) => {
        const data = dayjs(pedido.dataCadastro).format('DD/MM/YYYY HH:mm');
        const nomeCliente = pedido.clienteNome || "-";
        const quantidade = item.quantidade || "1";
        const valor = item.valor || "0,00";
        const subtotal = item.subtotal || "0,00";

        const descricaoFinal = (item.descricao || [])
          .filter((desc: any) => desc.categoria !== "Observação")
          .map((desc: any) => {
            const partes = [
              desc.descricao || "",
              desc.valor ? `R$ ${desc.valor}` : ""
            ];
            return partes.join(" | ");
          })
          .join(" + ");

        const valorNumerico = parseFloat(valor.replace(/\./g, '').replace(',', '.')) || 0;
        somaValor += valorNumerico;

        const subtotalNumerico = parseFloat(subtotal.replace(/\./g, '').replace(',', '.')) || 0;
        somaSubtotal += subtotalNumerico;

        contador++;
        arrayGeral.push([
          contador,
          data,
          descricaoFinal,
          quantidade,
          valor,
          subtotal,
          nomeCliente,
          pedido.origem // <-- nova coluna
        ]);
      });
    });

    // Total geral
    arrayGeral.push([
      "-",
      "-",
      "-",
      "-",
      somaValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      somaSubtotal.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      "-",
      "-"
    ]);

    setStateGeral(arrayGeral);

    if (exportFunction) {
      exportFunction(arrayGeral);
    }

    setShowLoading(false);
  }


  // Todos Pedidos e itens
  // async function carregarDados(situacao: any, cliente: any, data: any, exportFunction?: any) {
  //   setShowLoading(true);

  //   const [pedidos, caixa, comandas] = await Promise.all([
  //     carregarGeralSegmentada(situacao, cliente, data),
  //     carregarCaixaSegmentada(situacao, cliente, data),
  //     carregarComandasSegmentada(situacao, cliente, data)
  //   ]);

  //   let arrayGeral: any[] = [];
  //   let somaValor = 0;
  //   let somaSubtotal = 0;
  //   let contador = 0;

  //   arrayGeral.push(['#', 'Data', 'Produto', 'Qtd', 'Valor', 'Total', 'Cliente']);

  //   const todosItens = [...(pedidos || []), ...(caixa || []), ...(comandas || [])];

  //   // Ordenar por dataCadastro
  //   todosItens.sort((a, b) => new Date(a.dataCadastro).getTime() - new Date(b.dataCadastro).getTime());

  //   todosItens.forEach((pedido: any) => {
  //     if (!pedido.produtos || !Array.isArray(pedido.produtos)) return;

  //     pedido.produtos.forEach((item: any) => {
  //       const data = dayjs(pedido.dataCadastro).format('DD/MM/YYYY HH:mm');
  //       const nomeCliente = pedido.clienteNome || "-";
  //       const quantidade = item.quantidade || "1";
  //       const valor = item.valor || "0,00";
  //       const subtotal = item.subtotal || "0,00";

  //       // Monta a descrição com quebra de linha entre cada objeto
  //       const descricaoFinal = (item.descricao || [])
  //         .filter((desc: any) => desc.categoria !== "Observação") // <-- filtro aplicado aqui
  //         .map((desc: any) => {
  //           const partes = [
  //             desc.descricao || "-",
  //             desc.valor ? `R$ ${desc.valor}` : "-",
  //             desc.unidadeMedida || "-"
  //           ];
  //           return partes.join(" | ");
  //         })
  //         .join("<br>");


  //       const valorNumerico = parseFloat(valor.replace(/\./g, '').replace(',', '.')) || 0;
  //       somaValor += valorNumerico;

  //       const subtotalNumerico = parseFloat(subtotal.replace(/\./g, '').replace(',', '.')) || 0;
  //       somaSubtotal += subtotalNumerico;

  //       contador++;
  //       arrayGeral.push([
  //         contador,
  //         data,
  //         descricaoFinal,
  //         quantidade,
  //         valor,
  //         subtotalNumerico,
  //         nomeCliente
  //       ]);
  //     });
  //   });

  //   // Total geral
  //   arrayGeral.push([
  //     "-",
  //     "-",
  //     "-",
  //     "-",
  //     somaSubtotal.toLocaleString('pt-br', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     }),
  //     somaValor.toLocaleString('pt-br', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     }),

  //     "-"
  //   ]);

  //   setStateGeral(arrayGeral);

  //   if (exportFunction) {
  //     exportFunction(arrayGeral);
  //   }

  //   setShowLoading(false);
  // }

  // Todos Pedidos
  // async function carregarDados(situacao: any, cliente: any, data: any, exportFunction?: any) {
  //   setShowLoading(true);

  //   const [pedidos, caixa, comandas] = await Promise.all([
  //     carregarGeralSegmentada(situacao, cliente, data),
  //     carregarCaixaSegmentada(situacao, cliente, data),
  //     carregarComandasSegmentada(situacao, cliente, data)
  //   ]);

  //   let arrayGeral: any[] = [];
  //   let somaValor = 0;
  //   let contador = 0;

  //   arrayGeral.push(['#', 'Nome', 'Status', 'Data', 'Cliente', 'Telefone', 'Valor', 'Realizado', 'Avaliação', 'Comentário']);

  //   const formatarTelefone = (telefone: string | undefined) => {
  //     if (telefone?.length === 13) {
  //       const match = telefone.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
  //       if (match) {
  //         return `(${match[1]}) ${match[2]}-${match[3]}`;
  //       }
  //     }
  //     return "-";
  //   };

  //   // Junta todos os itens em um único array
  //   const todosItens = [...(pedidos || []), ...(caixa || []), ...(comandas || [])];

  //   // Ordena por dataCadastro (mais antigo primeiro; use `b - a` para ordem decrescente)
  //   todosItens.sort((a, b) => {
  //     const dataA = new Date(a.dataCadastro).getTime();
  //     const dataB = new Date(b.dataCadastro).getTime();
  //     return dataA - dataB;
  //   });

  //   // Monta a tabela
  //   todosItens.forEach((valor: any) => {
  //     contador++;

  //     const telefone = formatarTelefone(valor.clienteTelefone);
  //     const valorNumerico = valor.valorTotal ? parseFloat(valor.valorTotal.replace(/\./g, '').replace(',', '.')) : 0;
  //     somaValor += valorNumerico;

  //     arrayGeral.push([
  //       contador,
  //       valor.nomeProjeto || "-",
  //       valor.statusWorkflow || "-",
  //       dayjs(valor.dataCadastro).format('DD/MM/YYYY HH:mm') || "-",
  //       valor.clienteNome || "-",
  //       telefone,
  //       valor.valorTotal || "0,00",
  //       (valor.percentualTotalServicos || "0,00") + "%",
  //       valor.avaliacaoCliente || "Não avaliado",
  //       valor.comentarioCliente || "Não avaliado"
  //     ]);
  //   });

  //   // Linha de total
  //   arrayGeral.push([
  //     "-",
  //     "-",
  //     "-",
  //     "-",
  //     "-",
  //     "-",
  //     somaValor.toLocaleString('pt-br', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     }),
  //     "-",
  //     "-",
  //     "-"
  //   ]);

  //   setStateGeral(arrayGeral);

  //   if (exportFunction) {
  //     exportFunction(arrayGeral);
  //   }

  //   setShowLoading(false);
  // }

  async function gerarRelatorioPDF(arrayGeral: any) {

    (pdfMake as any).vfs = pdfFonts;

    const reportTitle: any = [{
      text: window.localStorage.getItem("servicoTipoPlural") || "Geral",
      fontSize: 15,
      bold: true,
      margin: [15, 20, 0, 45]  // left, top, riight, bottom
    }];

    const reportDetails: any = [
      { text: lojaSelecionadaNome, style: 'subheader' },
      { text: 'Data início: ' + dayjs(dataAgendamentoPeriodo1).format('DD/MM/YYYY'), style: 'subheader' },
      { text: 'Data fim: ' + dayjs(dataAgendamentoPeriodo2).format('DD/MM/YYYY'), style: 'subheader' },
      { text: 'Status: ' + (stateStatus == "Ativo" ? "Ativos" : "Encerrados"), style: 'subheader' },
      {
        table: {
          body: arrayGeral

        },
        layout: {
          fillColor: function (rowIndex: any, node: any, columnIndex: any) {
            return (rowIndex == 0) ? '#ff7000' : (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        },
        style: 'padrao'
      }
    ];

    function rodape(currentPage: any, pageCount: any) {
      return [
        {
          text: currentPage + ' / ' + pageCount,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0]
        }
      ]
    }

    const docDefinitions: any = {
      pageSize: 'A4',

      pageOrientation: 'landscape',

      pageMargin: [15, 50, 15, 40],

      content: [reportDetails],
      footer: rodape,
      styles: {
        header: {
          fontSize: 10,
          bold: true
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        padrao: {
          fontSize: 8
        }
      }
    }

    pdfMake.createPdf(docDefinitions).open();
  }

  const openPopoverInicio = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataInicio(true);
  };

  const openPopoverFim = (e: any) => {
    popover2.current!.event = e;
    setShowModalDataFim(true);
  };



  return (
    <IonPage className="relatorios-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="relatorios-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => { setStateGeral([]); setStateCarregado(false); history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>
          {/* <IonButtons slot="start">
            <IonButton>
              <IonIcon slot="icon-only" icon={apps} />
            </IonButton>
          </IonButtons> */}
          <IonTitle slot="start">Relatório Geral</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="relatorios-content">
        <div className="relatorios-container">
          <header className="relatorios-heading"><h1>Relatório Geral</h1><p>Consulte os resultados por período e exporte os dados do relatório.</p></header>
        <section className="relatorios-filters" hidden={stateCarregado}>
          <h2>Filtros do relatório</h2>
          <div className="relatorios-fields">


          <div className="relatorios-field">
            <span className="relatorios-label">Data início</span>
            <button className="relatorios-date" type="button" aria-label="Data início" onClick={e => { openPopoverInicio(e); }}><span>{dataAgendamentoPeriodo1Br}</span><IonIcon icon={calendarOutline} aria-hidden="true" /></button>
          </div>

          <div className="relatorios-field">
            <span className="relatorios-label">Data fim</span>
            <button className="relatorios-date" type="button" aria-label="Data fim" onClick={e => { openPopoverFim(e); }}><span>{dataAgendamentoPeriodo2Br}</span><IonIcon icon={calendarOutline} aria-hidden="true" /></button>
          </div>

          <div className="relatorios-field" hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
            <span className="relatorios-label">Loja</span>
            <IonSelect aria-label="Loja" name='Lojas' placeholder='Selecione as lojas' title='Lojas' value={lojaSelecionadaId} multiple={false} cancelText="Cancel" okText="Ok" onIonChange={e => {

              let found = JSON.parse(window.localStorage.getItem("lojas") || "[]").find((obj: any) => {
                return obj.empresaLojaId === e.detail.value;
              });
              if (found) {
                setLojaSelecionadaNome(found.empresaLojaNome);
              }
              setLojaSelecionadaId(e.detail.value);

            }} slot="end">
              {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                <IonSelectOption key={"lojaid" + valor.empresaLojaId} value={valor.empresaLojaId}>{valor.empresaLojaNome}</IonSelectOption>
              ))}
            </IonSelect>
          </div>
          <div className="relatorios-field" hidden={false}>
            <span className="relatorios-label">Status</span>
            <IonSelect aria-label="Status" value={stateStatus} onIonChange={(e) => { setStateStatus(e.detail.value); }}>
              <IonSelectOption value={'Ativo'}>Ativos</IonSelectOption>
              <IonSelectOption value={'Encerrado'}>Encerrados</IonSelectOption>

            </IonSelect>
          </div>


          </div>
          <div className="relatorios-search-action"><IonButton onClick={async () => { await carregarDados(stateStatus, lojaSelecionadaId, dataAgendamentoPeriodo1) }} expand="block" type="submit" fill="solid" className="relatorios-primary">Buscar</IonButton>
        </div>
        </section>

        <section className="relatorios-results" hidden={!stateCarregado}>
          <div className="relatorios-summary"><h2>Resultados do relatório</h2>
          <div className="relatorios-summary-item">{lojaSelecionadaNome}</div>
          <div className="relatorios-summary-item">Data início: {dayjs(dataAgendamentoPeriodo1).format("DD/MM/YYYY")}</div>
          <div className="relatorios-summary-item">Data fim: {dayjs(dataAgendamentoPeriodo2).format("DD/MM/YYYY")}</div>
          <div className="relatorios-summary-item">Status: {stateStatus == "Ativo" ? "Ativos" : "Encerrados"}</div>


          </div>
          <div className="relatorios-actions"><IonButton onClick={() => { setStateGeral([]); setStateCarregado(false); }} type="button" fill="outline" className="relatorios-secondary">Limpar</IonButton>
          <IonButton hidden={isPlatform("android") || isPlatform("ios")} onClick={() => gerarRelatorioPDF(stateGeral)} type="button" fill="outline" className="relatorios-secondary">Gerar PDF</IonButton>
          <CSVLink hidden={isPlatform("android") || isPlatform("ios")} data={stateGeral} separator={";"}><IonButton type="button" fill="outline" className="relatorios-secondary">Gerar CSV</IonButton></CSVLink>

          </div>

          <GeralTable model={stateGeral}></GeralTable>
        </section>
        </div>


        <IonPopover ref={popover1}
          isOpen={showModalDataInicio}
          onDidDismiss={() => setShowModalDataInicio(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo1Br(dataFormatada);
                  setDataAgendamentoPeriodo1(data);
                }
                //setShowModalDataInicio(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonPopover ref={popover2}
          isOpen={showModalDataFim}
          onDidDismiss={() => setShowModalDataFim(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo2Br(dataFormatada);
                  setDataAgendamentoPeriodo2(data);
                }
                //setShowModalDataFim(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'

        />
      </IonContent>
    </IonPage>
  );
};

export default RelatorioGeral;